import {useSyncExternalStore} from 'react';

const emptySubscribe = () => () => {};

/**
 * Hook that returns true after hydration is complete.
 * Uses useSyncExternalStore to properly handle SSR/client differences
 * without causing hydration mismatches.
 */
export function useHydrated(): boolean {
    return useSyncExternalStore(
        emptySubscribe,
        () => true, // Client value (after hydration)
        () => false // Server value
    );
}
